import React from "react";

import { CButton } from "@coreui/react";

const DashboardContentItem = props => (
  <CButton
    to={props.to}
    color="white"
    className={`p-0 d-flex w-100 border-default ${props.className || ""}`}
  >
    <div className="d-flex align-items-center w-100">
      <div
        className="d-flex align-items-center justify-content-center text-white rounded-left"
        style={{
          backgroundColor: props.color,
          height: "3.5rem",
          width: "3.5rem",
          fontSize: "1.5rem"
        }}
      >
        {props.icon}
      </div>
      <div
        className="flex-1 text-ellipsis d-flex align-items-center px-4"
        style={{ fontSize: "1rem" }}
      >
        <div
          className="text-ellipsis text-left"
          style={{ flex: 1, fontWeight: "bold" }}
        >
          {props.name}
        </div>
      </div>
    </div>
  </CButton>
);

export default DashboardContentItem;
